/* eslint-disable jsx-a11y/anchor-is-valid */
import { toAbsoluteUrl } from '../../../../_metronic/helpers/AssetHelpers'
import { CustomButton } from '../../widgets/components/UI/CustomButton'
import * as Yup from 'yup'
import { Formik, Form } from 'formik'
import { SelectInput } from '../../widgets/components/Input/SelectInput'
import TextInput from '../../widgets/components/Input/TextInput'
import { useIntl } from 'react-intl'
import { CompanyFieldsType, socialMediaType } from '../core/_models'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { industryOptions } from '../../../core/_constants'
import { companyInitialValues, operatingStatusOptions, teamSizeOptions } from '../core/_constants'
import TextArea from '../../widgets/components/Input/TextArea'
import { updateCompanyProfile } from '../core/_requests'
import { companySocialMediaData } from '../core/_constants'
import { FileUpload } from '../../widgets/components/FileUpload'
import { useAuth } from '../../auth'
import { DisplayImage } from '../../widgets/components/General/DisplayImage'
import '../../onboarding/styles/onboarding.scss'
import { toast } from 'react-toastify'
import { companyData } from '../../../../app/modules/profile/core/_requests'
import { useCurrency } from '../../../hooks/useCurrency'
import { ToolTipUI } from '../../widgets/components/UI/ToolTipUI'
import { useThemeMode } from '../../../../_metronic/partials'
import Skeleton from 'react-loading-skeleton'
import TagManager from 'react-gtm-module'
import { GTMEvent, companyDetailsMeta } from '../../../hooks/gtmHelpers'
import CreatableSelect from 'react-select/creatable'
import ColorPalette from './ColorPalette'
import brandingConfig from '../../../../config/brandingConfig'
import { Quill } from '../../widgets/components/Input/Quill'
import { removeNullFields } from '../../../core/_util'
import { getUserByToken } from '../../auth/core/_requests'

export function Company({
  key,
  setCompanyImgName,
  companyImgName,
  getCompanyApiLoading,
  setCountryId,
  countryOptions,
  companyLogoName,
  setCompanyLogoName,
  stateOptions,
  companyIconName,
  setCompanyIconName,
  companyLightLogoName,
  setCompanyLightLogoName,
  companyDarkLogoName,
  setCompanyDarkLogoName,
  selectedHashtags,
  setSelectedHastags,
  primaryColor,
  accentColor,
  setPrimaryColor,
  setAccentColor,
  getBillingDetails,
}: {
  key: number
  setCountryId: Dispatch<SetStateAction<string | undefined>>
  setCompanyImgName: Dispatch<SetStateAction<string | undefined>>
  companyImgName: string | undefined
  getCompanyApiLoading: boolean
  countryOptions: any
  stateOptions: any
  companyLogoName?: any
  setCompanyLogoName?: any
  companyIconName?: any
  setCompanyIconName?: any
  companyLightLogoName?: any
  setCompanyLightLogoName?: any
  companyDarkLogoName?: any
  setCompanyDarkLogoName?: any
  selectedHashtags?: any
  setSelectedHastags?: any
  primaryColor?: string
  accentColor?: string
  setPrimaryColor?: any
  setAccentColor?: any
  getBillingDetails?: () => Promise<void>
}) {
  const [loading, setLoading] = useState(false)
  const { saveAuth, setUserToken } = useAuth()
  const [modelStatus, setModelStatus] = useState<boolean>(false)
  const [darkModelStatus, setDarkModelStatus] = useState<boolean>(false)
  const [lightModelStatus, setLightModelStatus] = useState<boolean>(false)
  const { companyId, setBillingData, setEntitlements, setCompanyQueuePosition, setUseCase, setPlanStatus, setInvoiceStatus } = useAuth()
  const { formatMessage } = useIntl()
  const { currencyOptions } = useCurrency()
  const [selectedSidebarId, setSelectedSidebarId] = useState(1)
  const [companyQuillText, setCompanyQuillText] = useState('')
  const [quillText, setQuillText] = useState('')

  const transformHashtags = (hashtags: any) => {
    return hashtags.map((tag: any) => ({
      label: tag.tagName,
      value: tag.tagName,
    }))
  }
  // const [selectedHashtags, setSelectedHastags] = useState<object[]>([])

  const { mode } = useThemeMode()

  const generalSidebarOptions = [
    { tabTitle: formatMessage({ id: 'General' }), id: 1 },
    { tabTitle: formatMessage({ id: 'Profile' }), id: 2 },
    { tabTitle: formatMessage({ id: 'Branding' }), id: 3 },
    { tabTitle: formatMessage({ id: 'Links' }), id: 4 },
  ]

  const companyGeneralSchema = Yup.object().shape({
    companyName: Yup.string()
      .required(formatMessage({ id: 'Company name is required' }))
      .min(3, formatMessage({ id: 'Minimum 3 characters' })),
    // teamSize: Yup.string()
    //   .required(formatMessage({ id: 'Team size is required' }))
    //   .nullable(),
    legalName: Yup.string()
      .required(formatMessage({ id: 'Legal Name is required' }))
      .min(3, formatMessage({ id: 'Minimum 3 characters' })),
    operatingStatus: Yup.string().required(formatMessage({ id: 'Operating status is required' })),
    foundedDate: Yup.date().required(formatMessage({ id: 'Founded Date is required' })),
    // industry: Yup.string()
    //   .required(formatMessage({ id: 'Industry is required' }))
    //   .nullable(),
    // country: Yup.string()
    //   .required(formatMessage({ id: 'Country is required' }))
    //   .nullable(),
    // state: Yup.string()
    //   .required(formatMessage({ id: 'State/Province is required' }))
    //   .nullable(),
    city: Yup.string().required(formatMessage({ id: 'City is required' })),
    zipCode: Yup.number().required(formatMessage({ id: 'Zip Code is required' })),
    founders: Yup.string().required(formatMessage({ id: 'Founders is required' })),
  })
  const companyProfileSchema = Yup.object().shape({
    tagline: Yup.string()
      .required('Enter a valid tagline')
      .min(3, formatMessage({ id: 'Minimum 3 characters' })),

    description: Yup.string()
      .required('Please enter a valid description')
      .min(3, formatMessage({ id: 'Minimum 3 characters' })),
    shortDescription: Yup.string()
      .required('Please enter a valid description')
      .min(3, formatMessage({ id: 'Minimum 3 characters' })),
  })
  const companyLinkSchema = Yup.object().shape({
    socialMedia: Yup.object().shape({
      website: Yup.string().url(formatMessage({ id: 'Please Enter the valid URL' })),
      facebook: Yup.string().url(formatMessage({ id: 'Please Enter the valid URL' })),
      twitter: Yup.string().url(formatMessage({ id: 'Please Enter the valid URL' })),
      linkedin: Yup.string()
        .url(formatMessage({ id: 'Please Enter the valid URL' }))
        .nullable(),
      instagram: Yup.string().url(formatMessage({ id: 'Please Enter the valid URL' })),
      webApp: Yup.string().url(formatMessage({ id: 'Please Enter the valid URL' })),
      iosApp: Yup.string().url(formatMessage({ id: 'Please Enter the valid URL' })),
      androidApp: Yup.string().url(formatMessage({ id: 'Please Enter the valid URL' })),
      youtube: Yup.string().url(formatMessage({ id: 'Please Enter the valid URL' })),
      reddit: Yup.string().url(formatMessage({ id: 'Please Enter the valid URL' })),
      tiktok: Yup.string().url(formatMessage({ id: 'Please Enter the valid URL' })),
      whatsapp: Yup.string().url(formatMessage({ id: 'Please Enter the valid URL' })),
      telegram: Yup.string().url(formatMessage({ id: 'Please Enter the valid URL' })),
      snapchat: Yup.string().url(formatMessage({ id: 'Please Enter the valid URL' })),
      weChat: Yup.string().url(formatMessage({ id: 'Please Enter the valid URL' })),
      pinterest: Yup.string().url(formatMessage({ id: 'Please Enter the valid URL' })),
      discord: Yup.string().url(formatMessage({ id: 'Please Enter the valid URL' })),
      twitch: Yup.string().url(formatMessage({ id: 'Please Enter the valid URL' })),
    }),
  })

  const onSubmit = async (values: CompanyFieldsType) => {
    setLoading(true)
    const updateCompanyGeneral = {
      name: values.companyName,
      logoId: values.logoId,
      teamSize: Number(values.teamSize),
      legalName: values.legalName,
      operatingStatus: values.operatingStatus,
      currencyId: values.currencyId,
      foundedDate: values.foundedDate,
      industry: values.industry,
      countryId: Number(values.country),
      stateId: Number(values.state),
      city: values.city,
      zipCode: Number(values.zipCode),
      founders: values.founders,
      companyId: companyId,
    }
    const updateCompanyDataProfile = {
      name: values.companyName,
      industry: values.industry,
      countryId: values.country,
      stateId: values.state,
      companyId: companyId,
      shortDescription: values.shortDescription,
      description: values.description,
      problemStatement: values.problemStatement || '',
      USP: values.USP || '',
      ...(values.featuredImageId && { featuredImageId: values.featuredImageId }), // Conditionally include
      tagline: values.tagline,
      hashtags: selectedHashtags,
      city: values.city,
      zipCode: Number(values.zipCode),
    }

    const updateCompanyBranding = {
      name: values.companyName,
      industry: values.industry,
      countryId: values.country,
      stateId: values.state,
      companyId: companyId,
      ...(values.logoId !== undefined ? { logoId: values.logoId } : {}),
      ...(values.darkLogoId && { brandDarkLogoId: values.darkLogoId }),
      ...(values.lightLogoId && { brandLightLogoId: values.lightLogoId }),
      brandPrimaryColor: primaryColor,
      brandAccentColor: accentColor,
      city: values.city,
      zipCode: Number(values.zipCode),
    }
    const updateCompanyLinks = {
      name: values.companyName,
      industry: values.industry,
      countryId: values.country,
      stateId: values.state,
      companyId: companyId,
      website: values.socialMedia.website || '',
      facebook: values.socialMedia.facebook || '',
      twitter: values.socialMedia.twitter || '',
      linkedin: values.socialMedia.linkedin || '',
      instagram: values.socialMedia.instagram || '',
      webApp: values.socialMedia.webApp || '',
      iosApp: values.socialMedia.iosApp || '',
      androidApp: values.socialMedia.androidApp || '',
      youtube: values.socialMedia.youtube || '',
      reddit: values.socialMedia.reddit || '',
      tiktok: values.socialMedia.tiktok || '',
      whatsapp: values.socialMedia.whatsapp || '',
      telegram: values.socialMedia.telegram || '',
      snapchat: values.socialMedia.snapchat || '',
      weChat: values.socialMedia.weChat || '',
      pinterest: values.socialMedia.pinterest || '',
      discord: values.socialMedia.discord || '',
      twitch: values.socialMedia.twitch || '',
      city: values.city,
      zipCode: Number(values.zipCode),
    }

    let updateCompanyData: any = {}

    if (selectedSidebarId === 1) {
      updateCompanyData = { ...updateCompanyGeneral }
    } else if (selectedSidebarId === 2) {
      updateCompanyData = { ...updateCompanyDataProfile }
    } else if (selectedSidebarId === 3) {
      updateCompanyData = { ...updateCompanyBranding }
    } else if (selectedSidebarId === 4) {
      updateCompanyData = { ...updateCompanyLinks }
    }
    try {
      const {
        data: { success, errors, data },
      } = await updateCompanyProfile(updateCompanyData)
      if (success) {
        companySettingData()
        setLoading(false)
        toast.success(formatMessage({ id: 'Company updated successfully' }))
        await saveAuth(data)
        setUserToken(data.token)
        const { data: userData } = await getUserByToken(data.token)
        if (
          userData?.data
        ) {
          const findCompany = userData?.data?.company?.find(
            (company: { companyId: number }) => company.companyId === data?.companyId
          )
          if (findCompany) {
            setCompanyQueuePosition(findCompany?.queuePosition)
            setUseCase(findCompany?.useCase)
            if (userData?.data?.companyPlanStatus?.invoiceStatus) {
              setInvoiceStatus(userData.data.companyPlanStatus.invoiceStatus)
            }
            if (userData?.data?.companyPlanStatus?.planStatus) {
              setPlanStatus(userData.data.companyPlanStatus.planStatus)
            }

          }
        }
        const result: any = await getBillingDetails!()
        setBillingData({
          ...result.output,
          ...result.customer_info,
          renewal_estimate: result.renewal_estimate,
          transaction_id: result.current_plan_invoice_id,
          company_country: result.company_country,
        })
        setEntitlements(result.entitlement_list)
      } else {
        setLoading(false)
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.CompanySettingsUpdatedFailed,
            metadata: removeNullFields({
              errors: errors,
              company_id: companyId,
            }),
          },
        })

        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }
  const handleSelectChange = (selectedOptions: any) => {
    setSelectedHastags(selectedOptions)
  }

  const customStyles = {
    placeholder: (provided: any, state: any) => ({
      ...provided,
      fontSize: 13,
      fontWeight: 500,
    }),
    input: (provided: any, state: any) => ({
      ...provided,
      '&:focus': {
        boxShadow: 'none',
      },
      fontSize: 13,
      padding: 3,
    }),
    control: (baseStyles: any, state: any) => ({
      ...baseStyles,
      borderColor: state.isFocused ? '#b5b5c3' : '#e4e6ef',
      boxShadow: 'none',
      minHeight: '43px',
      maxHeight: '80px',
      overflowY: 'scroll',
    }),
    option: (styles: any, state: any) => ({
      ...styles,
      color: state.isSelected ? '#FFF' : styles.color,
      '&:hover': {
        color: '#4776E6',
        backgroundColor: '#E1E7ED',
      },
    }),
  }
  const DropdownIndicator = () => {
    return (
      <div className='me-3'>
        <img src={toAbsoluteUrl('/media/icons/investor/DownArrow.svg')} alt='search' />
      </div>
    )
  }

  const addHashtag = (val: string) => {
    setSelectedHastags((prev: any[]) => {
      const exists = prev.some((obj) => obj.value === val)

      if (exists) {
        return prev
      }
      return [...prev, { value: val, label: val }]
    })
  }
  const handleDarkOpen = () => {
    setDarkModelStatus(true)
  }
  const handleLightOpen = () => {
    setLightModelStatus(true)
  }
  const handleOpen = () => {
    setModelStatus(true)
  }
  const handleDarkClose = () => {
    setDarkModelStatus(false)
  }
  const handleLightClose = () => {
    setLightModelStatus(false)
  }
  const handleClose = () => {
    setModelStatus(false)
  }

  const companySettingData = async () => {
    if (companyId) {
      try {
        const {
          data: { success, data },
        } = await companyData(companyId)

        if (success) {
          setCompanyLogoName(data?.featuredImage?.name)
          setCompanyImgName(data?.file?.name)
          setSelectedHastags(transformHashtags(data.tags))
          setCompanyDarkLogoName(data?.brandDarkImage?.name)
          setCompanyLightLogoName(data?.brandLightImage?.name)
          setPrimaryColor(data?.brandPrimaryColor)
          setAccentColor(data?.brandAccentColor)
          companyInitialValues.companyName = data.name || ''
          companyInitialValues.tagline = data.tagline || ''
          companyInitialValues.teamSize = data.teamSize || 0
          companyInitialValues.legalName = data?.legalName || ''
          companyInitialValues.operatingStatus = data?.operatingStatus || ''
          companyInitialValues.currencyId = data.currencyId || 0
          companyInitialValues.shortDescription = data.shortDescription || ''
          companyInitialValues.description = data.description || ''
          companyInitialValues.foundedDate = data.foundedDate || ''
          companyInitialValues.problemStatement = data.problemStatement || ''
          companyInitialValues.USP = data.USP || ''
          companyInitialValues.industry = data.industry || ''
          companyInitialValues.country = data.countryId || 0
          companyInitialValues.state = data.stateId || 0
          companyInitialValues.founders = data?.founders || ''
          companyInitialValues.logoId = data?.logoId || ''
          companyInitialValues.zipCode = Number(data.zipCode) || 0
          companyInitialValues.socialMedia.website = data.website || ''
          companyInitialValues.socialMedia.facebook = data.facebook || ''
          companyInitialValues.socialMedia.twitter = data.twitter || ''
          companyInitialValues.socialMedia.linkedin = data.linkedin || ''
          companyInitialValues.socialMedia.instagram = data.instagram || ''
          companyInitialValues.socialMedia.webApp = data.webApp || ''
          companyInitialValues.socialMedia.iosApp = data.iosApp || ''
          companyInitialValues.socialMedia.androidApp = data.androidApp || ''
          companyInitialValues.socialMedia.youtube = data.youtube || ''
          companyInitialValues.socialMedia.reddit = data.reddit || ''
          companyInitialValues.socialMedia.tiktok = data.tiktok || ''
          companyInitialValues.socialMedia.whatsapp = data.whatsapp || ''
          companyInitialValues.socialMedia.telegram = data.telegram || ''
          companyInitialValues.socialMedia.snapchat = data.snapchat || ''
          companyInitialValues.socialMedia.weChat = data.weChat || ''
          companyInitialValues.socialMedia.pinterest = data.pinterest || ''
          companyInitialValues.socialMedia.discord = data.discord || ''
          companyInitialValues.socialMedia.twitch = data.twitch || ''

          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.CompanySettingsUpdatedSuccessful,
              metadata: removeNullFields(
                companyDetailsMeta({
                  ...data,
                  company_id: companyId,
                  profileImg: data.file?.name,
                })
              ),
            },
          })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }

  useEffect(() => {
    companySettingData()
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className='d-flex flex-md-row flex-column'>
        <div className='mb-9 sidebar-investor-db col-md-1 d-none d-md-flex ' style={{ width: '14%' }}>
          {generalSidebarOptions.map((sideTab: any) => (
            <ul className='text-muted text-active-primary d-md-flex flex-column d-none align-items-left p-0 m-0 cursor-pointer '>
              <li
                className={`nav-link text-active-primary py-3 ps-3 d-flex align-items-center ${selectedSidebarId === sideTab.id
                  ? '  border-top-0 border border-bottom-0 border-right-0 border-left-3 border-primary text-primary border-5'
                  : ''
                  }`}
                onClick={() => setSelectedSidebarId(sideTab.id)}
              >
                {formatMessage({ id: sideTab.tabTitle })}
              </li>
            </ul>
          ))}
        </div>

        <div className='mb-2 sidebar-investor-db col-md-1 d-flex d-md-none' style={{ width: '100%' }}>
          <div
            className='d-md-none d-flex'
            style={{
              display: 'flex',
              overflowX: 'scroll',
              whiteSpace: 'nowrap',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {generalSidebarOptions.map((sideTab: any) => (
              <ul
                key={sideTab.id}
                className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 flex-nowrap mobile-tab-both my-md-0 mb-2 d-md-none'
                style={{ display: 'flex', flexWrap: 'nowrap' }}
              >
                <li
                  className={`nav-link text-active-primary py-3 ps-3 d-flex align-items-center ${selectedSidebarId === sideTab.id
                    ? 'border-top-0 border border-left-0 border-right-0 border-bottom-3 border-primary text-primary border-5'
                    : ''
                    }`}
                  onClick={() => setSelectedSidebarId(sideTab.id)}
                >
                  {formatMessage({ id: sideTab.tabTitle })}
                </li>
              </ul>
            ))}
          </div>
        </div>

        <div
          className={`d-flex mb-9 px-7 rounded-2 w-100 ${mode !== 'dark' ? 'bg-white' : ''}`}
          style={{ background: '#1e1e2d' }}
        >
          {selectedSidebarId === 1 &&
            (getCompanyApiLoading ? (
              <>
                <div className='col-xl-12 d-md-flex' style={{ flexDirection: 'column' }}>
                  <div className='mt-4' style={{ width: '270px' }}>
                    <Skeleton
                      height={18}
                      width={120}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                    <div className={`position-relative d-flex justify-content-md-left my-2`}>
                      <Skeleton
                        width={130}
                        height={120}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    </div>

                    <p>
                      <Skeleton
                        height={12}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        width={220}
                      />
                      <Skeleton
                        height={12}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        width={100}
                      />
                    </p>
                  </div>

                  <div className='mt-9 w-100 px-5 px-md-0 mb-4'>
                    <div className='d-md-flex col-12  flex-wrap gap-20 mb-10'>
                      <div className='col-md-5 mb-10 mb-md-0 col-12'>
                        <div className='w-50'>
                          <Skeleton
                            height={18}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mt-2'>
                          <Skeleton
                            height={35}
                            width={'100%'}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                      <div className='col-md-5 col-12'>
                        <div className='w-50'>
                          <Skeleton
                            height={18}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mt-2'>
                          <Skeleton
                            height={35}
                            width={'100%'}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='d-md-flex col-12 flex-wrap gap-20 mb-10'>
                      <div className='col-md-5 col-12 mb-10 mb-md-0'>
                        <div className='w-50'>
                          <Skeleton
                            height={18}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mt-2'>
                          <Skeleton
                            height={35}
                            width={'100%'}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                      <div className='col-md-5 col-12'>
                        <div className='w-50'>
                          <Skeleton
                            height={18}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mt-2'>
                          <Skeleton
                            height={35}
                            width={'100%'}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='d-md-flex col-12 flex-wrap gap-20 mb-10'>
                      <div className='col-md-5 mb-10 col-12 mb-md-0'>
                        <div className='w-50'>
                          <Skeleton
                            height={18}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mt-2'>
                          <Skeleton
                            height={35}
                            width={'100%'}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                      <div className='col-md-5 col-12'>
                        <div className='w-50'>
                          <Skeleton
                            height={18}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mt-2'>
                          <Skeleton
                            height={35}
                            width={'100%'}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='d-md-flex col-12  flex-wrap gap-20 mb-10'>
                      <div className='col-md-5 col-12 mb-10 mb-md-0'>
                        <div className='w-50'>
                          <Skeleton
                            height={18}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mt-2'>
                          <Skeleton
                            height={35}
                            width={440}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                      <div className='col-md-5 col-12'>
                        <div className='w-50'>
                          <Skeleton
                            height={18}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mt-2'>
                          <Skeleton
                            height={35}
                            width={440}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='d-md-flex col-12 flex-wrap gap-20 mb-10'>
                      <div className='col-md-5  col-12 mb-10 mb-md-0'>
                        <div className='w-50'>
                          <Skeleton
                            height={18}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mt-2'>
                          <Skeleton
                            height={35}
                            width={440}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                      <div className='col-md-5 col-12'>
                        <div className='w-50'>
                          <Skeleton
                            height={18}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mt-2'>
                          <Skeleton
                            height={35}
                            width={440}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                    </div>

                    <div className='w-100 d-md-flex justify-content-md-end gap-4 align-items-md-end mt-10 h-md-100px'>
                      <div className='w-md-25 me-md-20'>
                        <Skeleton
                          height={40}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />{' '}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className='col-xl-12 col-12 d-md-flex ' style={{ flexDirection: 'column' }}>
                <div className='mt-4' style={{ width: '270px' }}>
                  <label
                    className='form-label font-size-13 mb-3  text-dark text-capitalize  ms-md-0  d-flex align-items-md-center  fw-normal mb-0 col-md-12'
                    htmlFor='kt_login_toc_agree'
                  >
                    {formatMessage({
                      id: 'Company Icon',
                    })}
                    <ToolTipUI
                      tooltipText={formatMessage({
                        id: 'Upload your company logo here.',
                      })}
                    />
                  </label>
                  <div
                    className={`cardC position-relative d-flex justify-content-center rounded`}
                    onClick={handleOpen}
                    style={{
                      height: '140px',
                      width: '140px',
                      boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.1)',
                    }}
                  >
                    <DisplayImage
                      // imgName={companyIconName}
                      imgName={companyImgName}
                      className='rounded'
                      width='140px'
                      height='140px'
                      alt={formatMessage({ id: 'profile' })}
                      fit='cover'
                      type='custom'
                      customUrl='recordskeeper-default-company-display-picture.svg'
                    />

                    <div
                      className='pencil-container cursor-pointer'
                      style={{ position: 'absolute', right: -10, top: -10 }}
                    >
                      <img src={toAbsoluteUrl('/media/icons/duotune/general/pencil.svg')} alt='' />
                    </div>
                  </div>
                  <p
                    className='mt-3'
                    style={{
                      font: 'Poppins',
                      fontWeight: 400,
                      fontSize: '12px',
                      lineHeight: '18px',
                      color: '#8898A6',
                    }}
                  >
                    {formatMessage({
                      id: 'Recommended size: 512x512 px (1:1 Ratio) JPG or PNG. Max size: 1MB',
                    })}
                  </p>
                </div>
                <div className='mt-9  w-100 px-0 px-md-0'>
                  <Formik
                    initialValues={companyInitialValues}
                    validationSchema={companyGeneralSchema}
                    onSubmit={onSubmit}
                    validateOnMount
                  >
                    {(formik) => {
                      setCountryId(formik.values.country)
                      return (
                        <Form>
                          <div className='d-md-flex col-md-12 flex-wrap'>
                            <FileUpload
                              fileSize={2097152}
                              maxFileNumber={1}
                              allowType={['image/*', '.jpg', '.jpeg', '.png']}
                              metaData={{ module: 'logo', isProtected: false }}
                              modalStatus={modelStatus}
                              handleClose={handleClose}
                              handleSuccess={(id: number, name: string) => {
                                setCompanyImgName(name)
                                formik.setFieldValue('logoId', id)
                              }}
                              resourceType='company_profile'
                            />
                            <div className='col-md-6 col-12'>
                              <TextInput
                                fieldType={'text'}
                                label={formatMessage({ id: 'Company Name' })}
                                fieldName={'companyName'}
                                formik={formik}
                                placeholder={formatMessage({ id: 'Enter the Company Name' })}
                                margin='me-6'
                                toolTipText={formatMessage({
                                  id: 'GLOBAL.TOOLTIP.COMPANY.COMPANY_NAME',
                                })}
                                width={11}
                                isStarRequired={true}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <div className='col-md-6 col-12'>
                              <TextInput
                                fieldType={'text'}
                                label={formatMessage({ id: 'Legal Name' })}
                                fieldName={'legalName'}
                                formik={formik}
                                placeholder={formatMessage({ id: 'Enter the Legal Name' })}
                                toolTipText={formatMessage({
                                  id: 'GLOBAL.TOOLTIP.COMPANY.LEGAL_NAME',
                                })}
                                width={11}
                                isStarRequired={true}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <div className='col-md-6 col-12'>
                              <SelectInput
                                label={formatMessage({ id: 'Team Size' })}
                                fieldName={'teamSize'}
                                formik={formik}
                                placeholder={formatMessage({ id: 'Select the Team Size' })}
                                margin={'me-md-6'}
                                toolTipText={formatMessage({
                                  id: 'GLOBAL.TOOLTIP.COMPANY.TEAM_SIZE',
                                })}
                                width={11}
                                options={teamSizeOptions}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <div className='col-md-6 col-12'>
                              <SelectInput
                                label={formatMessage({ id: 'Operating Status' })}
                                fieldName={'operatingStatus'}
                                placeholder={formatMessage({
                                  id: 'Select your Operating Status',
                                })}
                                formik={formik}
                                toolTipText={formatMessage({
                                  id: 'GLOBAL.TOOLTIP.COMPANY.OPERATING_STATUS',
                                })}
                                options={operatingStatusOptions}
                                margin='me-md-6'
                                width={11}
                                isStarRequired={true}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <div className='col-md-6 col-12'>
                              <TextInput
                                fieldType={'date'}
                                fieldName={'foundedDate'}
                                formik={formik}
                                placeholder={formatMessage({
                                  id: 'Select the Founding Date',
                                })}
                                margin='me-6'
                                label={formatMessage({ id: 'Founding Date' })}
                                toolTipText={formatMessage({
                                  id: 'GLOBAL.TOOLTIP.COMPANY.FOUNDING_DATE',
                                })}
                                width={11}
                                dateValue={formik.values.foundedDate}
                                isStarRequired={true}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <div className='col-md-6 col-12'>
                              <SelectInput
                                label={formatMessage({ id: 'Currency' })}
                                fieldName={'currencyId'}
                                placeholder={formatMessage({ id: 'Selected currency' })}
                                formik={formik}
                                toolTipText={formatMessage({
                                  id: 'GLOBAL.TOOLTIP.COMPANY.SELECT_CURRENCY',
                                })}
                                options={currencyOptions}
                                width={11}
                              />
                            </div>
                            <div className='col-md-6 col-12'>
                              <SelectInput
                                label={formatMessage({ id: 'Country' })}
                                fieldName={'country'}
                                placeholder={formatMessage({ id: 'Select Your Country' })}
                                formik={formik}
                                toolTipText={formatMessage({ id: 'GLOBAL.TOOLTIP.COMPANY.COUNTRY' })}
                                options={countryOptions}
                                width={11}
                                margin={'me-md-6'}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <div className='col-md-6 col-12'>
                              <SelectInput
                                label={formatMessage({ id: 'State/Province' })}
                                fieldName={'state'}
                                placeholder={formatMessage({ id: 'Select Your State or Province' })}
                                formik={formik}
                                toolTipText={formatMessage({ id: 'GLOBAL.TOOLTIP.COMPANY.STATE' })}
                                options={stateOptions}
                                width={11}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <div className='col-md-6 col-12'>
                              <TextInput
                                fieldType={'text'}
                                fieldName={'city'}
                                formik={formik}
                                placeholder={'Enter City'}
                                label={formatMessage({ id: 'City' })}
                                toolTipText={formatMessage({ id: 'GLOBAL.TOOLTIP.USER.EMAIL' })}
                                width={11}
                                isStarRequired={true}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <div className='col-md-6 col-12'>
                              <TextInput
                                fieldType={'number'}
                                fieldName={'zipCode'}
                                formik={formik}
                                placeholder={'Enter Zip Code'}
                                label={formatMessage({ id: 'Zip Code' })}
                                toolTipText={formatMessage({ id: 'GLOBAL.TOOLTIP.USER.EMAIL' })}
                                width={11}
                                isStarRequired={true}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <div className='col-md-6 col-12'>
                              <SelectInput
                                label={formatMessage({ id: 'Industry' })}
                                fieldName={'industry'}
                                placeholder={formatMessage({ id: 'Select Your Industry' })}
                                formik={formik}
                                toolTipText={formatMessage({ id: 'GLOBAL.TOOLTIP.COMPANY.INDUSTRY' })}
                                options={industryOptions}
                                width={11}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <div className='d-md-flex flex-md-column col-md-6 col-12'>
                              <TextInput
                                fieldType={'text'}
                                fieldName={'founders'}
                                formik={formik}
                                placeholder={formatMessage({ id: 'Enter the Founders' })}
                                label={formatMessage({ id: 'Founders' })}
                                toolTipText={formatMessage({ id: 'GLOBAL.TOOLTIP.COMPANY.FOUNDERS' })}
                                width={11}
                                isTooltipNotRequired={false}
                                isStarRequired={true}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>

                          <div className='d-md-flex justify-content-md-end button-margin me-md-10'>
                            <CustomButton
                              isSubmitting={formik.isSubmitting}
                              isValid={!formik.isValid || !loading}
                              buttonText={formatMessage({ id: 'Save Changes' })}
                              loading={loading}
                              widthLoading={2}
                              width={2}
                              margin={'me-md-3'}
                              height={44}
                            />
                          </div>
                        </Form>
                      )
                    }}
                  </Formik>
                </div>
              </div>
            ))}
          {selectedSidebarId === 2 &&
            (getCompanyApiLoading ? (
              <>
                <div className='col-xl-12 d-md-flex' style={{ flexDirection: 'column' }}>
                  <div className='mt-4' style={{ width: '270px' }}>
                    <Skeleton
                      height={18}
                      width={140}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                    <div className={`position-relative d-flex justify-content-md-left my-2`}>
                      <Skeleton
                        width={280}
                        height={150}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    </div>

                    <p>
                      <Skeleton
                        height={12}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        width={280}
                      />
                      <Skeleton
                        height={12}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        width={120}
                      />
                    </p>
                  </div>

                  <div className='mt-md-2 w-100 px-5 px-md-0 mb-4'>
                    <div className='d-md-flex col-md-12 flex-wrap gap-20 mb-10'>
                      <div className='col-md-5 mb-10 mb-md-0'>
                        <div className='w-50'>
                          <Skeleton
                            height={18}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mt-2'>
                          <Skeleton
                            height={35}
                            width={440}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                      <div className='col-md-5'>
                        <div className='w-50'>
                          <Skeleton
                            height={18}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mt-2'>
                          <Skeleton
                            height={35}
                            width={440}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='d-md-flex col-md-12 flex-wrap gap-20 mb-10'>
                      <div className='col-md-5 mb-10 mb-md-0'>
                        <div className='w-50'>
                          <Skeleton
                            height={18}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mt-2'>
                          <Skeleton
                            height={115}
                            width={440}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                      <div className='col-md-5'>
                        <div className='w-50'>
                          <Skeleton
                            height={18}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mt-2'>
                          <Skeleton
                            height={115}
                            width={440}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                      <div className='col-md-11 mb-10 mb-md-0'>
                        <div className='w-50'>
                          <Skeleton
                            height={18}
                            width={300}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mt-2'>
                          <Skeleton
                            height={150}
                            width={900}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                      <div className='col-md-11 mb-10 mb-md-0'>
                        <div className='w-50'>
                          <Skeleton
                            height={18}
                            width={300}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mt-2'>
                          <Skeleton
                            height={150}
                            width={900}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                    </div>

                    <div className='w-100 d-md-flex justify-content-md-end gap-4 align-items-md-end mt-10 h-md-100px'>
                      <div className='w-md-25 me-md-20'>
                        <Skeleton
                          height={40}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />{' '}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className='col-xl-12 col-12 d-md-flex flex-column'>
                <div className='mt-4' style={{ width: '270px' }}>
                  <label
                    className='form-label font-size-13 mb-3  text-dark text-capitalize  ms-md-0  d-flex align-items-md-center  fw-normal mb-0 col-md-12'
                    htmlFor='kt_login_toc_agree'
                  >
                    {formatMessage({
                      id: 'Featured Image',
                    })}
                    <ToolTipUI
                      tooltipText={formatMessage({
                        id: 'Upload a featured image for your company profile. This will be used in directories, social shares and listings.',
                      })}
                    />
                  </label>
                  <div
                    className={`cardC position-relative d-flex justify-content-center align-items-center`}
                    style={{ height: '161px', backgroundColor: '#E1EAFF' }}
                    onClick={handleOpen}
                  >
                    <DisplayImage
                      imgName={`${companyLogoName}`}
                      // width='175px'
                      // height='133px'
                      width='100%'
                      height='100%'
                      alt={formatMessage({ id: 'profile' })}
                      type='custom'
                      // fit='cover'
                      customUrl={`${brandingConfig.brandName === 'Foundercrate'
                        ? 'light-logo.svg'
                        : 'recordskeeper-ai-logo-for-light-mode.svg'
                        }`}
                    />

                    <div
                      className='pencil-container cursor-pointer'
                      style={{ position: 'absolute', right: -10, top: -10 }}
                    >
                      <img src={toAbsoluteUrl('/media/icons/duotune/general/pencil.svg')} alt='' />
                    </div>
                  </div>
                  <p
                    className='mt-2'
                    style={{
                      font: 'Poppins',
                      fontWeight: 400,
                      fontSize: '12px',
                      lineHeight: '18px',
                      color: '#8898A6',
                    }}
                  >
                    {formatMessage({
                      id: 'Recommended size: 1920x1080 px (16:9 Ratio) JPG or PNG. Max size: 1MB',
                    })}
                  </p>
                </div>

                <div className='mt-md-8  w-100 px-0 px-md-0'>
                  <Formik
                    initialValues={companyInitialValues}
                    validationSchema={companyProfileSchema}
                    onSubmit={onSubmit}
                  >
                    {(formik) => {
                      setCountryId(formik.values.country)
                      return (
                        <Form>
                          <div className='d-md-flex col-md-12 flex-wrap'>
                            <FileUpload
                              enforceAspectRatio='16:9'
                              fileSize={2097152}
                              maxFileNumber={1}
                              allowType={['image/*', '.jpg', '.jpeg', '.png']}
                              metaData={{ module: 'logo', isProtected: false }}
                              modalStatus={modelStatus}
                              handleClose={handleClose}
                              handleSuccess={(id: number, name: string) => {
                                setCompanyLogoName(name)
                                formik.setFieldValue('featuredImageId', id)
                              }}
                              resourceType='company_profile'
                            />
                            <div className='col-md-6 col-12'>
                              <TextInput
                                fieldType={'text'}
                                label={formatMessage({ id: 'Tagline (Elevator Pitch)' })}
                                fieldName={'tagline'}
                                formik={formik}
                                placeholder={formatMessage({
                                  id: 'Enter Tagline',
                                })}
                                toolTipText={formatMessage({ id: 'GLOBAL.TOOLTIP.COMPANY.TAGLINE' })}
                                width={11}
                                isStarRequired={true}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <div className='col-md-6 col-12 mb-7 mb-md-0'>
                              <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                                {formatMessage({ id: 'Hashtags' })}
                                <ToolTipUI
                                  tooltipText={formatMessage({
                                    id: 'List down the the responsibilities that the co-founder will be liable for.',
                                  })}
                                />
                              </label>
                              <CreatableSelect
                                isMulti
                                closeMenuOnSelect={true}
                                name='searchHashtag'
                                // options={groupData}
                                onCreateOption={(val) => {
                                  addHashtag(val)
                                }}
                                formatCreateLabel={(val) => `create ${val}`}
                                placeholder={formatMessage({ id: 'Enter Hashtag' })}
                                maxMenuHeight={200}
                                classNames={{
                                  control: (state: any) =>
                                    state.isFocused ? 'border-red-600' : 'border-grey-300',
                                }}
                                classNamePrefix='react-select'
                                styles={customStyles}
                                components={{ DropdownIndicator }}
                                value={selectedHashtags}
                                onChange={handleSelectChange}
                                theme={(theme: any) => ({
                                  ...theme,
                                  border: 0,
                                  borderRadius: 5,
                                  colors: {
                                    ...theme.colors,
                                    primary25: '#E1E7ED',
                                    primary: '#e4e6ef',
                                  },
                                })}
                                onBlur={formik.handleBlur}
                              />
                              {/* <TextInput
                                fieldType={'text'}
                                label={formatMessage({id: 'Hastags'})}
                                fieldName={'hashtags'}
                                formik={formik}
                                placeholder={formatMessage({
                                  id: 'Hastags',
                                })}
                                toolTipText={formatMessage({id: 'GLOBAL.TOOLTIP.COMPANY.TAGLINE'})}
                                width={11}
                              /> */}
                            </div>
                            <div className='col-md-6 col-12'>
                              <TextArea
                                fieldName={'shortDescription'}
                                formik={formik}
                                placeholder={formatMessage({
                                  id: 'Please enter short description about the company here',
                                })}
                                label={formatMessage({ id: 'Short Description of the Company' })}
                                toolTipText={formatMessage({
                                  id: 'GLOBAL.TOOLTIP.COMPANY.SHORT_DESCRIPTION',
                                })}
                                margin='me-md-6'
                                width={11}
                                isStarRequired={true}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <div className='col-md-6 col-12'>
                              <TextArea
                                fieldName={'description'}
                                formik={formik}
                                placeholder={formatMessage({
                                  id: 'Please enter long description about the company here',
                                })}
                                label={formatMessage({ id: 'Long Description of the Company' })}
                                toolTipText={formatMessage({
                                  id: 'GLOBAL.TOOLTIP.COMPANY.DESCRIPTION',
                                })}
                                width={11}
                                isStarRequired={true}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <div className='col-12'>
                              <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                                {formatMessage({ id: 'Problem this Company is Solving' })}
                                <ToolTipUI
                                  tooltipText={formatMessage({
                                    id: 'Briefly describe the main issue or challenge your company is addressing in the market.',
                                  })}
                                />
                              </label>
                              <div className='editor-container'>
                                <Quill
                                  height={'100'}
                                  formik={formik}
                                  isCompanyProfile={true}
                                  templateData={
                                    formik.values.problemStatement ||
                                    `<p>Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien.</p>
                                      <ul>
                                        <li>Lorem ipsum dolor sit amet consectetur adipiscing.</li>
                                        <li>Lorem ipsum dolor sit amet consectetur adipiscing.</li>
                                        <li>Lorem ipsum dolor sit amet consectetur adipiscing.</li>
                                      </ul>
                                    `
                                  }
                                  quillText={companyQuillText}
                                  setQuillText={setCompanyQuillText}
                                />
                              </div>
                            </div>
                            <div className='mt-8 col-12 width-400px'>
                              <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                                {formatMessage({ id: 'Unique Selling Proposition' })}
                                <ToolTipUI
                                  tooltipText={formatMessage({
                                    id: "Outline your company's unique strengths and what sets you apart from competitors.",
                                  })}
                                />
                              </label>
                              <div className='editor-container'>
                                <Quill
                                  height={'100'}
                                  formik={formik}
                                  templateData={
                                    formik.values.USP ||
                                    `<p>Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien.</p>
    <ul>
      <li>Lorem ipsum dolor sit amet consectetur adipiscing.</li>
      <li>Lorem ipsum dolor sit amet consectetur adipiscing.</li>
      <li>Lorem ipsum dolor sit amet consectetur adipiscing.</li>
    </ul>
  `
                                  }
                                  isUsp={true}
                                  quillText={quillText}
                                  setQuillText={setQuillText}
                                />
                              </div>

                            </div>
                          </div>

                          <div className='d-md-flex mt-6 mt-md-20 justify-content-md-end button-margin me-md-10'>
                            <CustomButton
                              isSubmitting={formik.isSubmitting}
                              isValid={!formik.isValid || !loading}
                              buttonText={formatMessage({ id: 'Save Changes' })}
                              loading={loading}
                              widthLoading={2}
                              width={2}
                              margin={'me-md-3'}
                              height={44}
                            />
                          </div>
                        </Form>
                      )
                    }}
                  </Formik>
                </div>
              </div>
            ))}
          {selectedSidebarId === 3 &&
            (getCompanyApiLoading ? (
              <>
                <div className='col-xl-12 col-12 d-md-flex flex-column'>
                  {/* Brand Logos for Emails */}
                  <div className='mt-4'>
                    <Skeleton
                      height={18}
                      width={180}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                    <div className='d-flex gap-13 flex-column flex-md-row'>
                      <div className='mt-3' style={{ width: '270px' }}>
                        <Skeleton
                          height={18}
                          width={150}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                        <div className='position-relative d-flex justify-content-center align-items-center my-2'>
                          <Skeleton
                            width={268}
                            height={108}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <p>
                          <Skeleton
                            height={12}
                            width={270}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                          <Skeleton
                            height={12}
                            width={70}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </p>
                      </div>

                      <div className='mt-3' style={{ width: '270px' }}>
                        <Skeleton
                          height={18}
                          width={150}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                        <div className='position-relative d-flex justify-content-center align-items-center my-2'>
                          <Skeleton
                            width={268}
                            height={108}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <p>
                          <Skeleton
                            height={12}
                            width={270}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                          <Skeleton
                            height={12}
                            width={70}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </p>
                      </div>
                    </div>
                    <p>
                      <Skeleton
                        height={12}
                        width={490}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    </p>
                  </div>

                  {/* Brand Colors */}
                  <div className='mt-4'>
                    <Skeleton
                      height={18}
                      width={180}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                    <div className='d-flex gap-3 mt-3'>
                      <Skeleton
                        height={40}
                        width={140}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                      <Skeleton
                        height={40}
                        width={140}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className='mt-9 mb-2 w-100 px-0 px-md-0 ' style={{ textAlign: 'right' }}>
                    <Skeleton
                      height={40}
                      width={150}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
              </>
            ) : (
              <div className='col-xl-12 col-12 d-md-flex ' style={{ flexDirection: 'column' }}>
                {/* <div className='mt-4' style={{ width: '270px' }}>
                  <label
                    className='form-label font-size-13 mb-3  text-dark text-capitalize  ms-md-0  d-flex align-items-md-center  fw-normal mb-0 col-md-12'
                    htmlFor='kt_login_toc_agree'
                  >
                    {formatMessage({
                      id: 'Company Icon',
                    })}
                    <ToolTipUI
                      tooltipText={formatMessage({
                        id: 'Upload your company logo here.',
                      })}
                    />
                  </label>
                  <div
                    className={`cardC position-relative d-flex justify-content-center`}
                    onClick={handleOpen}
                    style={{
                      height: '140px',
                      width: '150px',
                      boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.1)',
                    }}
                  >
                    <DisplayImage
                      // imgName={companyIconName}
                      imgName={companyImgName}
                      width='120px'
                      height='150px'
                      alt={formatMessage({id: 'profile'})}
                      fit='contain'
                      type='custom'
                      customUrl='companyIcon.svg'
                    />

                    <div
                      className='pencil-container'
                      style={{position: 'absolute', right: -9, top: -7}}
                    >
                      <img src={toAbsoluteUrl('/media/icons/duotune/general/pencil.svg')} alt='' />
                    </div>
                  </div>
                  <p
                    className='mt-3'
                    style={{
                      font: 'Poppins',
                      fontWeight: 400,
                      fontSize: '12px',
                      lineHeight: '18px',
                      color: '#8898A6',
                    }}
                  >
                    {formatMessage({
                      id: 'Recommended size: 512x512 px (1:1 Ratio) JPG or PNG. Max size: 1MB',
                    })}
                  </p>
                </div> */}

                <div className='mt-4'>
                  <label
                    className='form-label font-size-13 mb-3  text-dark text-capitalize  ms-md-0  d-flex align-items-md-center  fw-500 mb-0 col-md-12'
                    htmlFor='kt_login_toc_agree'
                  >
                    {formatMessage({
                      id: 'Brand logo for Emails',
                    })}
                    <ToolTipUI
                      tooltipText={formatMessage({
                        id: 'Upload the logo that will appear in email communications.',
                      })}
                    />
                  </label>
                  <div className='d-flex flex-sm-row flex-column gap-13'>
                    <div className='mt-3' style={{ width: '270px' }}>
                      <label
                        className='form-label font-size-13 mb-3  text-dark text-capitalize  ms-md-0  d-flex align-items-md-center  fw-normal mb-0 col-md-12'
                        htmlFor='kt_login_toc_agree'
                      >
                        {formatMessage({
                          id: 'Light Mode Logo',
                        })}
                        <ToolTipUI
                          tooltipText={formatMessage({
                            id: 'Upload a logo for light mode. This logo will be used for various internal or external communications and will be used in light mode based display.',
                          })}
                        />
                      </label>
                      <div
                        className={`cardC position-relative d-flex justify-content-center align-items-center`}
                        onClick={handleLightOpen}
                        style={{
                          height: '108px',
                          width: '268px',
                          boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.1)',
                          backgroundColor: '#F5F5F5',
                        }}
                      >
                        <DisplayImage
                          imgName={companyLightLogoName}
                          // width='125.70px'
                          width={`${brandingConfig.brandName === 'Foundercrate' ? '125.70px' : '175.70px'
                            }`}
                          height='133px'
                          alt={formatMessage({ id: 'profile' })}
                          fit='contain'
                          type='custom'
                          // customUrl={`${brandingConfig.brandName === 'Foundercrate' ? 'light-logo.svg' : 'RecordsKeeper-AI-logo-light-mode.svg'}`}
                          customUrl={`${brandingConfig.brandName === 'Foundercrate'
                            ? 'light-logo.svg'
                            : 'recordskeeper-ai-logo-for-light-mode.svg'
                            }`}
                        // customUrl='light-logo.svg'
                        //  customUrl='RecordsKeeper-AI-logo-light-mode.svg'
                        />

                        <div
                          className='pencil-container'
                          style={{ position: 'absolute', right: -9, top: -7 }}
                        >
                          <img
                            src={toAbsoluteUrl('/media/icons/duotune/general/pencil.svg')}
                            alt=''
                          />
                        </div>
                      </div>
                      <p
                        className='mt-2'
                        style={{
                          font: 'Poppins',
                          fontWeight: 400,
                          fontSize: '12px',
                          lineHeight: '18px',
                          color: '#8898A6',
                        }}
                      >
                        {formatMessage({
                          id: 'Image should be transparent PNG only. Max size: 512 kb, Ratio: 200x60 px',
                        })}
                      </p>
                    </div>
                    <div className='mt-3' style={{ width: '270px' }}>
                      <label
                        className='form-label font-size-13 mb-3  text-dark text-capitalize  ms-md-0  d-flex align-items-md-center  fw-normal mb-0 col-md-12'
                        htmlFor='kt_login_toc_agree'
                      >
                        {formatMessage({
                          id: 'Dark Mode Logo',
                        })}
                        <ToolTipUI
                          tooltipText={formatMessage({
                            id: 'Upload a logo for dark mode. This logo will be used for various internal or external communications and will be used in dark mode based display.',
                          })}
                        />
                      </label>
                      <div
                        className={`cardC position-relative d-flex justify-content-center align-items-center`}
                        onClick={handleDarkOpen}
                        style={{
                          height: '108px',
                          width: '268px',
                          boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.1)',
                          backgroundColor: '#383940',
                        }}
                      >
                        <DisplayImage
                          imgName={companyDarkLogoName}
                          // width='125.70px'
                          width={`${brandingConfig.brandName === 'Foundercrate' ? '125.70px' : '175.70px'
                            }`}
                          height='133px'
                          alt={formatMessage({ id: 'profile' })}
                          fit='contain'
                          type='custom'
                          customUrl={`${brandingConfig.brandName === 'Foundercrate'
                            ? 'dark-logo.svg'
                            : 'recordskeeper-ai-logo-for-dark-mode.svg'
                            }`}
                        // customUrl='dark-logo.svg'
                        />

                        <div
                          className='pencil-container'
                          style={{ position: 'absolute', right: -9, top: -7 }}
                        >
                          <img
                            src={toAbsoluteUrl('/media/icons/duotune/general/pencil.svg')}
                            alt=''
                          />
                        </div>
                      </div>
                      <p
                        className='mt-2'
                        style={{
                          font: 'Poppins',
                          fontWeight: 400,
                          fontSize: '12px',
                          lineHeight: '18px',
                          color: '#8898A6',
                        }}
                      >
                        {formatMessage({
                          id: 'Image should be transparent PNG only. Max size: 512 kb, Ratio: 200x60 px',
                        })}
                      </p>
                    </div>
                  </div>
                  <p
                    className='mt-1'
                    style={{
                      color: '#8898A6',
                    }}
                  >
                    {formatMessage({
                      id: `If logos are not set, the default ${brandingConfig.brandName} brand logo will appear in the emails.`,
                    })}
                  </p>
                </div>
                <div className='mt-7'>
                  <label
                    className='form-label font-size-13 mb-3  text-dark text-capitalize  ms-md-0  d-flex align-items-md-center  fw-500 mb-0 col-md-12'
                    htmlFor='kt_login_toc_agree'
                  >
                    {formatMessage({
                      id: 'Brand Colors',
                    })}
                    <ToolTipUI
                      tooltipText={formatMessage({
                        id: 'Please select the colors that matches to your company brand color theme.',
                      })}
                    />
                  </label>
                  <ColorPalette
                    primaryColor={primaryColor}
                    accentColor={accentColor}
                    setPrimaryColor={setPrimaryColor}
                    setAccentColor={setAccentColor}
                  />
                </div>

                <div className='mt-md-1  w-100 px-0 px-md-0'>
                  <Formik
                    initialValues={companyInitialValues}
                    validationSchema={companyGeneralSchema}
                    onSubmit={onSubmit}
                    validateOnMount
                  >
                    {(formik) => {
                      setCountryId(formik.values.country)
                      return (
                        <Form>
                          <div className='d-md-flex col-md-12 flex-wrap'>
                            <FileUpload
                              fileSize={2097152}
                              maxFileNumber={1}
                              allowType={['image/*', '.jpg', '.jpeg', '.png']}
                              metaData={{ module: 'logo', isProtected: false }}
                              modalStatus={modelStatus}
                              handleClose={handleClose}
                              handleSuccess={(id: number, name: string) => {
                                setCompanyImgName(name)
                                formik.setFieldValue('logoId', id)
                              }}
                              resourceType='all'
                            />
                            <FileUpload
                              fileSize={2097152}
                              maxFileNumber={1}
                              allowType={['image/*', '.jpg', '.jpeg', '.png']}
                              metaData={{ module: 'logo', isProtected: false }}
                              modalStatus={lightModelStatus}
                              handleClose={handleLightClose}
                              handleSuccess={(id: number, name: string) => {
                                setCompanyLightLogoName(name)
                                formik.setFieldValue('lightLogoId', id)
                              }}
                              resourceType='all'
                            />
                            <FileUpload
                              fileSize={2097152}
                              maxFileNumber={1}
                              allowType={['image/*', '.jpg', '.jpeg', '.png']}
                              metaData={{ module: 'logo', isProtected: false }}
                              modalStatus={darkModelStatus}
                              handleClose={handleDarkClose}
                              handleSuccess={(id: number, name: string) => {
                                setCompanyDarkLogoName(name)
                                formik.setFieldValue('darkLogoId', id)
                              }}
                              resourceType='all'
                            />
                          </div>

                          <div className='d-md-flex justify-content-md-end mt-15 button-margin me-md-10'>
                            <CustomButton
                              isSubmitting={formik.isSubmitting}
                              isValid={!formik.isValid || !loading}
                              buttonText={formatMessage({ id: 'Save Changes' })}
                              loading={loading}
                              widthLoading={2}
                              width={2}
                              margin={'me-md-3'}
                              height={44}
                            />
                          </div>
                        </Form>
                      )
                    }}
                  </Formik>
                </div>
              </div>
            ))}
          {selectedSidebarId === 4 &&
            (getCompanyApiLoading ? (
              <>
                <div className='col-xl-12 d-md-flex' style={{ flexDirection: 'column' }}>
                  <div className='mt-4' style={{ width: '270px' }}>
                    <Skeleton
                      height={21}
                      width={180}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>

                  <div className='d-md-flex mt-5 col-md-12 flex-wrap gap-20 mb-10'>
                    <div className='col-md-5 mb-10 mb-md-0'>
                      <div className='w-50'>
                        <Skeleton
                          height={18}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='mt-2'>
                        <Skeleton
                          height={35}
                          width={440}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                    <div className='col-md-5'>
                      <div className='w-50'>
                        <Skeleton
                          height={18}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='mt-2'>
                        <Skeleton
                          height={35}
                          width={440}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                  </div>

                  <div className='mt-4' style={{ width: '270px' }}>
                    <Skeleton
                      height={21}
                      width={180}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>

                  <div className='d-md-flex mt-5 col-md-12 flex-wrap gap-20 mb-10'>
                    <div className='col-md-5 mb-10 mb-md-0'>
                      <div className='w-50'>
                        <Skeleton
                          height={18}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='mt-2'>
                        <Skeleton
                          height={35}
                          width={440}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                    <div className='col-md-5'>
                      <div className='w-50'>
                        <Skeleton
                          height={18}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='mt-2'>
                        <Skeleton
                          height={35}
                          width={440}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                  </div>

                  <div className='mt-4' style={{ width: '270px' }}>
                    <Skeleton
                      height={21}
                      width={180}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>

                  <div className='d-md-flex mt-5 col-md-12 flex-wrap gap-20 mb-10'>
                    <div className='col-md-5 mb-10 mb-md-0'>
                      <div className='w-50'>
                        <Skeleton
                          height={18}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='mt-2'>
                        <Skeleton
                          height={35}
                          width={440}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                    <div className='col-md-5'>
                      <div className='w-50'>
                        <Skeleton
                          height={18}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='mt-2'>
                        <Skeleton
                          height={35}
                          width={440}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                  </div>

                  <div className='d-md-flex col-md-12 flex-wrap gap-20 mb-10'>
                    <div className='col-md-5 mb-10 mb-md-0'>
                      <div className='w-50'>
                        <Skeleton
                          height={18}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='mt-2'>
                        <Skeleton
                          height={35}
                          width={440}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                    <div className='col-md-5'>
                      <div className='w-50'>
                        <Skeleton
                          height={18}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='mt-2'>
                        <Skeleton
                          height={35}
                          width={440}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                  </div>

                  <div className='d-md-flex  col-md-12 flex-wrap gap-20 mb-10'>
                    <div className='col-md-5 mb-10 mb-md-0'>
                      <div className='w-50'>
                        <Skeleton
                          height={18}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='mt-2'>
                        <Skeleton
                          height={35}
                          width={440}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                    <div className='col-md-5'>
                      <div className='w-50'>
                        <Skeleton
                          height={18}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='mt-2'>
                        <Skeleton
                          height={35}
                          width={440}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='d-md-flex  col-md-12 flex-wrap gap-20 mb-10'>
                    <div className='col-md-5 mb-10 mb-md-0'>
                      <div className='w-50'>
                        <Skeleton
                          height={18}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='mt-2'>
                        <Skeleton
                          height={35}
                          width={440}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                    <div className='col-md-5'>
                      <div className='w-50'>
                        <Skeleton
                          height={18}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='mt-2'>
                        <Skeleton
                          height={35}
                          width={440}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='d-md-flex  col-md-12 flex-wrap gap-20 mb-10'>
                    <div className='col-md-5 mb-10 mb-md-0'>
                      <div className='w-50'>
                        <Skeleton
                          height={18}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='mt-2'>
                        <Skeleton
                          height={35}
                          width={440}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                    <div className='col-md-5'>
                      <div className='w-50'>
                        <Skeleton
                          height={18}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='mt-2'>
                        <Skeleton
                          height={35}
                          width={440}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='d-md-flex  col-md-12 flex-wrap gap-20 mb-10'>
                    <div className='col-md-5 mb-10 mb-md-0'>
                      <div className='w-50'>
                        <Skeleton
                          height={18}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='mt-2'>
                        <Skeleton
                          height={35}
                          width={440}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                    <div className='col-md-5'>
                      <div className='w-50'>
                        <Skeleton
                          height={18}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='mt-2'>
                        <Skeleton
                          height={35}
                          width={440}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='w-100 d-md-flex justify-content-md-end gap-4 align-items-md-end mb-3 h-md-100px'>
                    <div className='w-md-25 me-md-20'>
                      <Skeleton
                        height={40}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />{' '}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className='col-xl-12 col-12 d-md-flex'>
                <div className='mt-4 w-100 px-0 px-md-0'>
                  <Formik
                    initialValues={companyInitialValues}
                    validationSchema={companyLinkSchema}
                    onSubmit={onSubmit}
                  >
                    {(formik) => {
                      setCountryId(formik.values.country)
                      return (
                        <Form>
                          <div className='d-md-flex col-md-12 col-12 flex-wrap'>
                            <div className='p-md-0 p-md-auto col-12 p-3 w-100'>
                              <div
                                className='mb-4 text-dark'
                                style={{
                                  fontSize: '13px',
                                  fontWeight: 500,
                                }}
                              >
                                {formatMessage({ id: 'Website & Web App' })}
                              </div>

                              <div className='d-md-flex col-md-12  col-12 flex-wrap'>
                                <div className='d-flex flex-column col-md-6  gap-1 col-12'>
                                  <div className='d-flex align-items-center me-md-3 gap-3'>
                                    <img
                                      src={toAbsoluteUrl(`/media/icons/duotune/social/website.svg`)}
                                      width='20px'
                                      height='20px'
                                      alt={formatMessage({ id: 'website' })}
                                    />
                                    <label
                                      className='form-label font-size-13 text-dark text-capitalize  ms-md-0  d-flex align-items-md-center  fw-normal mb-0 col-12 col-md-12'
                                      style={{ color: '#585960' }}
                                      htmlFor='kt_login_toc_agree'
                                    >
                                      {formatMessage({
                                        id: 'Website',
                                      })}
                                    </label>
                                  </div>
                                  <TextInput
                                    fieldType={'url'}
                                    fieldName={'socialMedia.website'}
                                    formik={formik}
                                    placeholder={formatMessage({ id: 'Enter Website URL here' })}
                                    width={11}
                                    isTooltipNotRequired={true}
                                  // isBeside={true}
                                  // labelWidth='w-125px'
                                  />
                                </div>

                                <div className='d-flex flex-column  gap-1 col-md-6  col-12 '>
                                  <div className='d-flex align-items-center me-md-3 gap-3'>
                                    <img
                                      src={toAbsoluteUrl(`/media/icons/duotune/social/webapp.svg`)}
                                      width='20px'
                                      height='20px'
                                      alt={formatMessage({ id: 'web app' })}
                                    />
                                    <label
                                      className='form-label font-size-13 text-dark text-capitalize  ms-md-0  d-flex align-items-md-center  fw-normal mb-0 col-md-12'
                                      style={{ color: '#585960' }}
                                      htmlFor='kt_login_toc_agree'
                                    >
                                      {formatMessage({
                                        id: 'Web App Link',
                                      })}
                                    </label>
                                  </div>
                                  <TextInput
                                    fieldType={'url'}
                                    fieldName={'socialMedia.webApp'}
                                    formik={formik}
                                    placeholder={formatMessage({ id: 'Enter Web App URL here' })}
                                    width={11}
                                    isTooltipNotRequired={true}
                                    // isBeside={true}
                                    labelWidth='w-125px'
                                  />
                                </div>
                              </div>

                              <div
                                className='mb-4 text-dark'
                                style={{
                                  fontSize: '13px',
                                  fontWeight: 500,
                                }}
                              >
                                {formatMessage({ id: 'Mobile Apps' })}
                              </div>

                              <div className='d-md-flex col-md-12 flex-wrap'>
                                <div className='d-flex flex-column  gap-1 col-md-6 col-12'>
                                  <div className='d-flex align-items-center me-md-3 gap-3'>
                                    <img
                                      src={toAbsoluteUrl(`/media/icons/duotune/social/iosapp.svg`)}
                                      width='20px'
                                      height='20px'
                                      alt={formatMessage({ id: 'IOS App' })}
                                    />
                                    <label
                                      className='form-label font-size-13 text-dark text-capitalize  ms-md-0  d-flex align-items-md-center  fw-normal mb-0 col-md-12'
                                      style={{ color: '#585960' }}
                                      htmlFor='kt_login_toc_agree'
                                    >
                                      {formatMessage({
                                        id: 'iOS App Link',
                                      })}
                                    </label>
                                  </div>
                                  <TextInput
                                    fieldType={'url'}
                                    fieldName={'socialMedia.iosApp'}
                                    formik={formik}
                                    placeholder={formatMessage({ id: 'Enter IOS App URL here' })}
                                    width={11}
                                    isTooltipNotRequired={true}
                                  // isBeside={true}
                                  // labelWidth='w-125px'
                                  />
                                </div>

                                <div className='d-flex flex-column  gap-1 col-md-6 col-12'>
                                  <div className='d-flex align-items-center me-md-3 gap-3'>
                                    <img
                                      src={toAbsoluteUrl(
                                        `/media/icons/duotune/social/androidapp.svg`
                                      )}
                                      width='20px'
                                      height='20px'
                                      alt={formatMessage({ id: 'Android App' })}
                                    />
                                    <label
                                      className='form-label font-size-13 text-dark text-capitalize  ms-md-0  d-flex align-items-md-center  fw-normal mb-0 col-md-12'
                                      style={{ color: '#585960' }}
                                      htmlFor='kt_login_toc_agree'
                                    >
                                      {formatMessage({
                                        id: 'Android App Link',
                                      })}
                                    </label>
                                  </div>
                                  <TextInput
                                    fieldType={'url'}
                                    fieldName={'socialMedia.androidApp'}
                                    formik={formik}
                                    placeholder={formatMessage({ id: 'Enter Android App URL here' })}
                                    width={11}
                                    isTooltipNotRequired={true}
                                    // isBeside={true}
                                    labelWidth='w-125px'
                                  />
                                </div>
                              </div>

                              <div
                                className='mb-4 text-dark'
                                style={{
                                  fontSize: '13px',
                                  fontWeight: 500,
                                }}
                              >
                                {formatMessage({ id: 'Social Media Links' })}
                              </div>
                            </div>
                          </div>

                          <div className='d-md-flex col-md-12 flex-wrap'>
                            {companySocialMediaData.map(
                              ({ id, icon, iconLable, placeholder, fieldName }: socialMediaType) => (
                                <div
                                  className='d-flex flex-column  gap-1 col-md-6 col-12 '
                                  key={id}
                                >
                                  <div className='d-flex align-items-center me-md-3 gap-3'>
                                    <img
                                      src={toAbsoluteUrl(`/media/icons/duotune/social/${icon}`)}
                                      width='20px'
                                      height='20px'
                                      alt={formatMessage({ id: iconLable })}
                                    />

                                    <label
                                      className='form-label font-size-13 text-dark text-capitalize  ms-md-0  d-flex align-items-md-center  fw-normal mb-0 col-md-12'
                                      style={{ color: '#585960' }}
                                      htmlFor='kt_login_toc_agree'
                                    >
                                      {iconLable}
                                    </label>
                                  </div>

                                  <TextInput
                                    fieldType={'url'}
                                    fieldName={fieldName}
                                    formik={formik}
                                    placeholder={formatMessage({ id: placeholder })}
                                    // label={formatMessage({id: iconLable})}
                                    width={11}
                                    isTooltipNotRequired={true}
                                  // isBeside={true}
                                  // labelWidth='w-125px'
                                  />
                                </div>
                              )
                            )}
                          </div>

                          <div className='d-md-flex justify-content-md-end  button-margin me-md-10'>
                            <CustomButton
                              isSubmitting={formik.isSubmitting}
                              isValid={!formik.isValid || !loading}
                              buttonText={formatMessage({ id: 'Save Changes' })}
                              loading={loading}
                              widthLoading={2}
                              width={2}
                              margin={'me-md-3'}
                              height={44}
                            />
                          </div>
                        </Form>
                      )
                    }}
                  </Formik>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  )
}
